import * as R from 'ramda';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import useWidth from '../../../components/Hooks/useWidth';
import MoneyRendererV3 from '../../../components/Money/MoneyRendererV3/MoneyRendererV3';
import { MoneyRendererV3DirectionEnum } from '../../../components/Money/MoneyRendererV3/moneyRendererV3.types';
import MarkupChip from '../MarkupChip';
import { ProductPricesRendererProps } from './interfaces/product-prices.interfaces';
import useProductPricesRenderer from './useProductPricesRenderer';

export const useStyles = makeStyles()((theme) => ({
  iconButtonWithoutPadding: {
    padding: 0,
  },
  popoverPaper: {
    borderRadius: theme.spacing(2),
    background: theme.palette.grey[500],
    color: theme.palette.primary.contrastText,
  },
  tooltip: {
    maxWidth: '90vw',
    overflowWrap: 'break-word',
  },
  wrap: {
    flexWrap: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down(370)]: {
      flexWrap: 'wrap',
      '& > .MuiGrid-item': {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
}));

const ProductPricesRenderer = ({
  prices,
  retailPriceDisabled,
  showAllPrices = true,
  hasOrderItemQuantity,
  wholesalePriceDisabled,
}: ProductPricesRendererProps) => {
  const { mobileWidth } = useWidth();

  const { pricesConfig, showMarkup, showRetailPrice, markup } = useProductPricesRenderer({
    hasOrderItemQuantity,
    prices,
    showAllPrices,
  });
  const canShowRetailPrice = !retailPriceDisabled && showRetailPrice;

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', rowGap: '2px' }}
    >
      {!R.isNil(pricesConfig.minWholesalePrice) && !wholesalePriceDisabled && (
        <MoneyRendererV3
          direction={MoneyRendererV3DirectionEnum.ROW}
          promotionTextColor="textPrimary"
          promotionValue={pricesConfig.minPromotionalPrice}
          size={mobileWidth ? 'small' : 'medium'}
          value={pricesConfig.minWholesalePrice}
        />
      )}

      {!R.isNil(pricesConfig.minRetailPrice) && canShowRetailPrice && (
        <div
          style={{
            display: 'flex',
            columnGap: '6px',
          }}
        >
          <MoneyRendererV3
            color="textSecondary"
            size={mobileWidth ? 'extraSmall' : 'small'}
            value={pricesConfig.minRetailPrice}
          />
          {showMarkup && markup && (
            <MarkupChip markupValue={markup} fontSize={mobileWidth ? 10 : 12} />
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(ProductPricesRenderer);
